import { render, staticRenderFns } from "./platcontractfile.vue?vue&type=template&id=c01f71fc&"
import script from "./platcontractfile.vue?vue&type=script&lang=js&"
export * from "./platcontractfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports